var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTableArrowDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46669 11.9333C9.06669 12.4667 8.26669 12.4667 7.86669 11.9333L3.86669 6.6C3.37226 5.94076 3.84264 5 4.66669 5L12.6667 5C13.4907 5 13.9611 5.94077 13.4667 6.6L9.46669 11.9333Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableArrowDesc);
export default __webpack_public_path__ + "static/media/table-arrow-desc.903227acbe2e2fdf13c757e860f126ee.svg";
export { ForwardRef as ReactComponent };